import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';

import { DateProvider } from '../../../providers';
import {
  Container,
  Points,
  QuarterContainer,
  QuarterTime,
  SecondsFake,
  TeamsContainer,
  TeamContainer,
  TeamImage,
  TeamName,
  Timer,
  TimerContainer,
} from './styles';

function BasketballNba({ data }) {
  const { awayTeam, homeTeam, quarter, status, time } = data;
  const [, refresh] = useState(Date.now());

  useEffect(() => {
    const interval = setInterval(() => refresh(Date.now()), 1000);
    if (status === 'paused') clearInterval(interval);
    return () => {
      clearInterval(interval);
    };
  }, [status]);

  const getTime = () => {
    if (time.length === 0) return '10:00';
    const [minutes, seconds] = DateProvider.getBasketballTime(time);
    return `${minutes}:${seconds}`;
  };

  return (
    <>
      <Helmet>
        <link
          href="https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap"
          rel="stylesheet"
        />
      </Helmet>
      <Container>
        <TeamsContainer>
          <TeamContainer style={{ background: homeTeam?.color }}>
            {homeTeam.image && (
              <TeamImage alt="Home Team logo" src={homeTeam.image} />
            )}
            <TeamName>{homeTeam.name}</TeamName>
            <Points>{homeTeam.points}</Points>
          </TeamContainer>
          <TeamContainer style={{ background: awayTeam?.color }}>
            {awayTeam.image && (
              <TeamImage alt="Away Team logo" src={awayTeam.image} />
            )}
            <TeamName>{awayTeam.name}</TeamName>
            <Points>{awayTeam.points}</Points>
          </TeamContainer>
        </TeamsContainer>
        <TimerContainer>
          <Timer>{getTime()}</Timer>
          <QuarterContainer>
            <QuarterTime>{`${quarter}º`}</QuarterTime>
            <SecondsFake />
          </QuarterContainer>
        </TimerContainer>
      </Container>
    </>
  );
}

BasketballNba.propTypes = {
  data: PropTypes.shape({
    awayTeam: PropTypes.shape({
      colors: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.string,
          value: PropTypes.string,
        })
      ),
      image: PropTypes.string,
      name: PropTypes.string,
      points: PropTypes.number,
    }),
    homeTeam: PropTypes.shape({
      colors: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.string,
          value: PropTypes.string,
        })
      ),
      image: PropTypes.string,
      name: PropTypes.string,
      points: PropTypes.number,
    }),
    quarter: PropTypes.number,
    status: PropTypes.string,
    time: PropTypes.arrayOf(PropTypes.number),
  }),
  styles: PropTypes.shape({}),
};

BasketballNba.defaultProps = {
  data: {
    awayTeam: {
      color: '#1F2C58',
      image:
        'https://overlayon.s3.eu-west-3.amazonaws.com/pacers-logo.png',
      name: 'IND',
      points: 0,
    },
    homeTeam: {
      color: '#2A2F42',
      image:
        'https://overlayon.s3.eu-west-3.amazonaws.com/wizards-logo.png',
      name: 'WSH',
      points: 0,
    },
    quarter: 1,
    status: 'paused',
    time: [1626284505589, 1626285105589],
  },
  styles: {},
};

export default BasketballNba;
